export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  onlyAtivos(state) {
    return state.onlyAtivos;
  },
  hasCustomFilters(state) {
    return [
      state.onlyAtivos,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = ['entidade is not null'];
    if (state.searchText) {
      const searchTextFilter = `(descricao like '%${state.searchText.toLowerCase()}%' or codigo like '%${state.searchText.toLowerCase()}%')`;
      filters.push(searchTextFilter);
    }
    if (state.onlyAtivos) {
      const onlyAtivosFilter = 'ativo is true';
      filters.push(onlyAtivosFilter);
    }
    return filters.join(' and ');
  },
};
